const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB dalam bytes

export { MAX_FILE_SIZE }